import clsx from 'clsx'
import { Button, Modal } from 'avo-ui'
import icX from '../../../assets/images/ic-x.svg'

const ModalForm = ({ className, classNameContent, show, onHide, title, children, isDisabled, isLoading, onSubmit }) => {
    return (
        <Modal
            dialogClassName={clsx('w-[450px]', className)}
            contentClassName={'rounded-xl'}
            show={show}
            onHide={onHide}
        >
            <div className={'flex flex-row px-6 py-5 items-center justify-between'}>
                <div />
                <p className={'font-bold text-blue-90 text-lg mt-2'}>{title}</p>
                <img className={'w-5 -mt-8 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
            </div>
            <div className={classNameContent}>{children}</div>
            <div className={'px-6 py-3 flex justify-center'}>
                <Button
                    className={'w-[200px]'}
                    title={'Submit'}
                    disabled={isDisabled}
                    loading={isLoading}
                    onClick={onSubmit}
                />
            </div>
        </Modal>
    )
}

export default ModalForm
